/* Cached commerce utilities extracted from theme.liquid. */
/* =====================================================
   FLEXYPE CHECKOUT OPEN / CLOSE
===================================================== */
document.addEventListener("click", function(e) {
  if (e.target.closest('[name="checkout"]') || e.target.closest('.flexy-checkout-btn')) {
    document.body.classList.add('flexype-open');
  }
});

document.addEventListener("flexype:close", function() {
  document.body.classList.remove('flexype-open');
});

(function () {
  const METER_MULTIPLIER = 0.25;
  const productIsMeterCache = new Map();

  function formatQty(n) {
    const v = Math.round(n * 100) / 100;
    const s = String(v);
    return s.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
  }

  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Request failed');
    return res.json();
  }

  async function isMeterHandle(handle) {
    if (!handle) return false;
    if (productIsMeterCache.has(handle)) return productIsMeterCache.get(handle);
    try {
      const product = await fetchJSON(`/products/${handle}.js`);
      const rawTags = product?.tags;
      const tags = Array.isArray(rawTags)
        ? rawTags
        : (typeof rawTags === 'string'
            ? rawTags.split(',').map(t => t.trim()).filter(Boolean)
            : []);
      const isMeter = tags.some(t => String(t).toLowerCase().includes('qty_meter'));
      productIsMeterCache.set(handle, isMeter);
      return isMeter;
    } catch (e) {
      productIsMeterCache.set(handle, false);
      return false;
    }
  }

  function findQtyNodeForTitle(title) {
    if (!title) return null;
    const lis = Array.from(document.querySelectorAll('li'));
    const li = lis.find(x => (x.textContent || '').trim() === title);
    if (!li) return null;
    const root = li.closest('div') || li.parentElement;
    if (!root) return null;
    const qtyP = root.querySelector('p');
    if (!qtyP) return null;
    const txt = (qtyP.textContent || '').trim();
    if (!/^\d+$/.test(txt)) return null;
    return qtyP;
  }

  async function applyFlexyPeQtyDisplayFix() {
    if (!document.body.classList.contains('flexype-open')) return;
    let cart;
    try {
      cart = await fetchJSON('/cart.js');
    } catch (e) {
      return;
    }

    const items = Array.isArray(cart?.items) ? cart.items : [];
    const meterHandles = new Set();
    await Promise.all(items.map(async (it) => {
      if (await isMeterHandle(it?.handle)) meterHandles.add(it.handle);
    }));

    items.forEach(it => {
      if (!meterHandles.has(it.handle)) return;
      const title = (it?.product_title || it?.title || '').trim();
      const qtyNode = findQtyNodeForTitle(title);
      if (!qtyNode) return;
      const shopifyQty = Number(it.quantity);
      if (!Number.isFinite(shopifyQty)) return;
      qtyNode.textContent = formatQty(shopifyQty * METER_MULTIPLIER);
    });
  }

  let observer;
  let scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(async () => {
      scheduled = false;
      await applyFlexyPeQtyDisplayFix();
    });
  }

  function ensureObserver() {
    if (observer) return;
    observer = new MutationObserver(() => {
      if (!document.body.classList.contains('flexype-open')) return;
      schedule();
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="checkout"]') || e.target.closest('.flexy-checkout-btn')) {
      ensureObserver();
      setTimeout(schedule, 250);
      setTimeout(schedule, 1000);
    }
  });

  document.addEventListener('flexype:close', function () {
    schedule();
  });
})();

/* =====================================================
   SHARED HELPERS (SINGLE SOURCE OF TRUTH)
===================================================== */
function getStep(input) {
  const step = parseFloat(input?.getAttribute("step"));
  return !isNaN(step) && step > 0 ? step : 1;
}

function roundToStep(value, step) {
  const decimals = (step.toString().split(".")[1] || "").length;
  return parseFloat(value.toFixed(decimals));
}

/* =====================================================
   CART QUANTITY HANDLER
   (MATCHES SHOPIFY PRODUCT PAGE BEHAVIOR)
===================================================== */
document.addEventListener("click", function (e) {

  /* ---------- NORMAL CART ---------- */
  const normalBtn = e.target.closest(".qty-btn");
  if (normalBtn) {
    const box = normalBtn.closest(".qty-box");
    const input = box?.querySelector(".cart-qty-input");
    if (!input) return;

    const action = normalBtn.classList.contains("plus") ? "increase" : "decrease";
    handleQuantityChange(input, action);
    return;
  }

  /* ---------- PREMIUM CART ---------- */
  const premiumBtn = e.target.closest(
    ".ai-premium-cart-quantity-button-at3u3dkyzl28vqur3daigenblock7cb65368utwxk"
  );
  if (!premiumBtn) return;

  const container = premiumBtn.closest(
    ".ai-premium-cart-quantity-at3u3dkyzl28vqur3daigenblock7cb65368utwxk"
  );
  if (!container) return;

  const input = container.querySelector(
    ".ai-premium-cart-quantity-input-at3u3dkyzl28vqur3daigenblock7cb65368utwxk"
  );
  if (!input) return;

  handleQuantityChange(input, premiumBtn.dataset.action);
});

/* =====================================================
   CORE QUANTITY LOGIC (PDP-STYLE)
===================================================== */
function handleQuantityChange(input, action) {

  const step = getStep(input);            // 🔑 SAME AS PDP
  const line = input.dataset.line;

  let value = parseFloat(input.value);
  if (isNaN(value)) value = step;

  if (action === "increase") value += step;
  if (action === "decrease") value = Math.max(step, value - step);

  value = roundToStep(value, step);
  input.value = value;

  const shopifyQuantity = step < 1 ? Math.round(value / step) : value;
  updateCart(line, shopifyQuantity);
}

/* =====================================================
   BLUR VALIDATION (MANUAL INPUT)
===================================================== */
document.addEventListener("blur", function(e) {

  const input = e.target.closest(
    ".cart-qty-input, .ai-premium-cart-quantity-input-at3u3dkyzl28vqur3daigenblock7cb65368utwxk"
  );
  if (!input) return;

  const step = getStep(input);
  let value = parseFloat(input.value);

  if (isNaN(value) || value < step) value = step;

  input.value = roundToStep(value, step);

  const line = input.dataset.line;
  const shopifyQuantity = step < 1 ? Math.round(value / step) : value;
  updateCart(line, shopifyQuantity);

}, true);

/* =====================================================
   SHOPIFY CART UPDATE (SINGLE CALL)
===================================================== */
function updateCart(line, quantity) {
  if (!line) return;

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      line: Number(line),
      quantity: quantity
    })
  })
  .then(() => {
    document.dispatchEvent(new CustomEvent("cart:updated"));
  })
  .catch(err => console.warn("❌ Cart error:", err));
}

/* =====================================================
   READ DECIMAL QUANTITY FROM #qty-new (PRODUCT PAGE)
===================================================== */
function getQuantityFromInput() {
  const input = document.getElementById("qty-new");
  if (!input) return 1;

  const step = getStep(input);
  let value = parseFloat(input.value);

  if (isNaN(value) || value < step) value = step;

  return roundToStep(value, step);
}

document.getElementById("qty-new")?.addEventListener("blur", function () {
  this.value = getQuantityFromInput();
});

/* =====================================================
   FORCE CART ICON → /cart
===================================================== */
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const cartIcon = e.target.closest(".cart-slider-trigger");
    if (!cartIcon) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = "/cart";
  }, true);
});

/* =====================================================
   DISABLE MINI CART COMPLETELY
===================================================== */
(function () {

  function disableMiniCart(e) {
    const cart = e.target.closest(".cart-slider-trigger");
    if (!cart) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    document.querySelectorAll(".cart-wrapper").forEach(w => {
      w.style.display = "none";
    });
  }

  document.addEventListener("mouseenter", disableMiniCart, true);
  document.addEventListener("mouseover", disableMiniCart, true);

  document.addEventListener("click", function(e) {
    const cart = e.target.closest(".cart-slider-trigger");
    if (!cart) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = "/cart";
  }, true);

})();
